export const RECURRENCE_RULE_END_TYPES = {
  never: 0,
  date: 1,
  after: 2,
};
